import React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from '../../common/ClientProvider';
import { FortiusClientService } from "./FortiusClientService";

const FortiusClientServiceContext = React.createContext<FortiusClientService | undefined>(undefined);

export const FortiusClientServiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { currentClientId } = useClient();

    const service = React.useMemo(
        () => new FortiusClientService(getAccessTokenSilently, currentClientId),
        [getAccessTokenSilently, currentClientId]
    );

    return (
        <FortiusClientServiceContext.Provider value={service}>
            {children}
        </FortiusClientServiceContext.Provider>
    );
};

export const useFortiusClientService = (): FortiusClientService => {
    const context = React.useContext(FortiusClientServiceContext);
    if (!context) throw new Error('useFortiusClientService must be used within a FortiusClientServiceProvider');
    return context;
};
